// extracted by mini-css-extract-plugin
export default {"mainContainer":"RegistrationDeposit_mainContainer__-NtZZ","contentContainer":"RegistrationDeposit_contentContainer__EKCnL","numberInput":"RegistrationDeposit_numberInput__xF8N0"};